import React from 'react'
import styled from '@emotion/styled/macro'
import { Redirect } from 'react-router-dom'
import { ImageContent } from '../shared/styled'
import PropTypes from 'prop-types'
import ImageList from '../shared/image-list'
import { graphql } from '@apollo/client/react/hoc'
import getAllOccasions from '../../graphql/getAllOccasions'
import GiftOfChoice from '../gift-of-choice'
import { trackImpression } from '../../utils/analytics'
import { handleSessionError } from '../../utils/error-tracking'
import { flowRight as compose } from 'lodash'
import { Message } from '@paypalcorp/worldready-react'

const Title = styled.h1`
  font-size: 30px;
  color: #4a4a4a;
  text-align: center;
  margin: auto;
  padding-top: 36px;
  padding-bottom: 36px;
`

export class Occasions extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.object,
      getAllOccasions: PropTypes.array,
    }).isRequired,
  }

  componentDidMount() {
    trackImpression(
      'main:consumer:gifts:home:',
      'main:consumer:gifts:home:occasions:::',
    )

    window.scrollTo(0, 0)
  }

  render() {
    if (this.props.data.loading) {
      return (
        <div className="vx_has-spinner-large" style={{ paddingTop: '400px' }} />
      )
    }
    if (this.props.data.error) {
      handleSessionError(this.props.data.error)
      return <Redirect to="/error" />
    }

    const occasions = this.props.data.getAllOccasions

    return (
      <div id="choose-an-occasion">
        <Title className="vx_text-2">
          <Message id="pages/occasions.occasions.header" />
        </Title>
        <div id="content-wrapper" style={{ textAlign: 'center' }}>
          <ImageContent>
            <ImageList items={occasions} />
          </ImageContent>
        </div>
        <GiftOfChoice parentPage="occasions" />
      </div>
    )
  }
}

const OccasionsWithData = compose(graphql(getAllOccasions))(Occasions)

export default OccasionsWithData
